import {Directive, ElementRef, inject, output} from '@angular/core';

@Directive({
  selector: '[libOutsideClick]',
  host: {
    '(document:click)': 'onOutsideClick($event)',
  },
})
export class OutsideClickDirective {
  readonly #el: ElementRef<HTMLElement> = inject(ElementRef);

  libOutsideClick = output();

  onOutsideClick(event: MouseEvent): void {
    const clickedHost = this.#el.nativeElement.contains(event.target as HTMLElement);

    if (!clickedHost) {
      this.libOutsideClick.emit();
    }
  }
}
